<script>
    import PriceControl from "../components/controls/PriceControl.svelte";

    export let location;
    export let vehicles;
    export let onChange = () => {};
</script>

<div class="location-item">
    <div class="name">
        {location.name}
        <div class="parent text-gray">
            {location.parent_name}
        </div>
    </div>
    <div class="prices">
        {#each Object.keys(location.prices) as vehicle_type_id}
            <div class="price-item form-item">
                <div class="form-item-info top">{vehicles[vehicle_type_id]}</div>
                <PriceControl bind:value={location.prices[vehicle_type_id]} onChange={onChange} warnOnEmpty/>
            </div>
        {/each}
    </div>
</div>

<style>
    .location-item {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 5px 0;
    }

    .location-item .name {
        width: 300px;
        font-weight: 500;
    }

    .location-item .name .parent {
        font-weight: 300;
        font-size: 12px;
        line-height: 1;
    }

    .location-item .prices {
        display: flex;
        gap: 5px;
    }
</style>